import { ITradableShift as ITradableShift } from "./tradable-shift";

export enum ShiftTradeTypeEnum {
	None = 0,
	Initiated = 1,
	Accepted = 2,
}

export interface ITradeShift extends ITradableShift {
	tradeType: ShiftTradeTypeEnum;
	fromShiftId: number;
	toShiftId: number;
}

export class TradeShift implements ITradeShift {
	readonly id: number;
	readonly tradeType: ShiftTradeTypeEnum;
	readonly employeeId: number;
	readonly fromShiftId: number;
	readonly toShiftId: number;
	readonly employeeName: string;
	readonly date: Date;
	readonly inTime?: Date;
	readonly outTime?: Date;
	readonly stationId: number;
	readonly stationName: string;
	readonly system: string;
	readonly professionName: string;
	readonly locationId?: number;
	readonly locationName?: string;
	readonly comment?: string;

	constructor(values: ITradeShift, system: string, professionName: string) {
		this.id = values.id;
		this.tradeType = values.tradeType;
		this.employeeId = values.employeeId;
		this.fromShiftId = values.fromShiftId;
		this.toShiftId = values.toShiftId;
		this.employeeName = values.employeeName;
		this.date = new Date(values.date);
		this.inTime = new Date(values.inTime!);
		this.outTime = new Date(values.outTime!);
		this.stationId = values.stationId;
		this.stationName = values.stationName;
		this.system = system;
		this.professionName = professionName;
		this.locationId = values.locationId;
		this.locationName = values.locationName;
		this.comment = values.comment;
	}
}
